export default __webpack_public_path__ + "static/media/1867.4da45cb1.png";